var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_58273",
    "data-name": "Group 58273",
    transform: "translate(-848.526 -221.276)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1186",
    "data-name": "Ellipse 1186",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(848.526 221.276)",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "close_FILL1_wght300_GRAD0_opsz24",
    d: "M214.746-734.84l-.9-.9,4.76-4.76-4.76-4.76.9-.9,4.76,4.76,4.76-4.76.9.9-4.76,4.76,4.76,4.76-.9.9-4.76-4.76Z",
    transform: "translate(644.285 977.035)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close_icon.68705e47974406e6e2d900e2f3224c88.svg";
export { ForwardRef as ReactComponent };